import json_anything from '@tehshrike/json_anything'
import { Temporal } from '@js-temporal/polyfill' // Replaced with native Temporal in the client build
import type { FinancialNumber } from 'financial-number'
import fnum from '#shared/fnum.ts'
import is_financial_number from '#shared/is_financial_number.ts'
import { base64_to_uint8array, uint8array_to_base64 } from '#shared/uint8array.ts'

const { serialize, deserialize } = json_anything({
	unique_key: `2687A5DC-E4E9-4E20-8BE0-B82113E8BA1E`,
	types: {
		bigint: {
			can_serialize: (value): value is bigint => typeof value === `bigint`,
			serialize: (value: bigint) => value.toString(),
			deserialize: (value: string) => BigInt(value),
		},
		temporal_instant: {
			can_serialize: (value): value is Temporal.Instant => value instanceof Temporal.Instant,
			serialize: (value: Temporal.Instant) => value.toString(),
			deserialize: (value: string) => Temporal.Instant.from(value),
		},
		temporal_plain_date: {
			can_serialize: (value): value is Temporal.PlainDate => value instanceof Temporal.PlainDate,
			serialize: (value: Temporal.PlainDate) => value.toString(),
			deserialize: (value: string) => Temporal.PlainDate.from(value),
		},
		temporal_plain_time: {
			can_serialize: (value): value is Temporal.PlainTime => value instanceof Temporal.PlainTime,
			serialize: (value: Temporal.PlainTime) => value.toString(),
			deserialize: (value: string) => Temporal.PlainTime.from(value),
		},
		financial_number: {
			can_serialize: is_financial_number,
			serialize: (number: FinancialNumber) => number.toString(),
			deserialize: (number_string: string) => fnum(number_string),
		},
		uint8array: {
			can_serialize: (value): value is Uint8Array => value instanceof Uint8Array,
			serialize: uint8array_to_base64,
			deserialize: base64_to_uint8array,
		},
	},
})

export { serialize, deserialize }
